import {
  CollectionName,
  CollectionVisibility,
} from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const exportCertificatesSchema: CollectionCreateSchema = {
  name: CollectionName.ExportCertificates,
  enable_nested_fields: true,
  token_separators: ["/"],
  fields: [
    {
      name: "party_id",
      type: "string",
      facet: false,
      infix: true,
    },
    {
      name: "country_id",
      type: "string",
      facet: true,
      infix: true,
    },
    {
      name: "country_name",
      type: "string",
      facet: true,
      infix: true,
      optional: true,
      sort: true,
    },
    {
      name: "request_name",
      type: "string",
      facet: false,
      infix: true,
      optional: true,
    },
    {
      name: "status",
      type: "string",
      facet: true,
      sort: true,
      infix: true,
      optional: true,
    },
    {
      name: "status_label",
      type: "string",
      facet: true,
      infix: true,
      optional: true,
      sort: true,
    },
    {
      name: "certificate_number",
      type: "string",
      facet: true,
      infix: true,
      sort: true,
    },
    {
      name: "certificate_number_sort",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "departure_date",
      type: "string",
      facet: true,
      optional: true,
      infix: true,
      index: true,
      sort: true,
    },
    {
      name: "departure_ts",
      type: "int64",
      facet: true,
      optional: true,
      infix: false,
      index: true,
      sort: true,
    },
    {
      name: "modified_at",
      type: "string",
      facet: true,
      optional: true,
      infix: true,
      sort: true,
      index: true,
    },
    {
      name: "modified_ts",
      type: "int64",
      facet: false,
      optional: true,
      infix: true,
      index: true,
      sort: true,
    },
    {
      name: "template_code",
      type: "string",
      optional: true,
      facet: true,
      infix: true,
      sort: true,
    },
    {
      name: "organisation",
      type: "string",
      optional: true,
      facet: true,
      infix: true,
      sort: true,
    },
    {
      name: "accessible_by",
      type: "string[]",
      optional: true,
      infix: true,
    },
    {
      name: "unofficial_information",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "submitted_at",
      type: "int64",
      optional: true,
      infix: true,
      facet: true,
      sort: true,
    },
    {
      name: "approved_at",
      type: "int64",
      optional: true,
      infix: true,
      facet: true,
      sort: true,
    },
    {
      name: "destination_country",
      type: "string",
      optional: true,
      facet: true,
      infix: true,
      sort: true,
    },
    {
      name: "destination_country_name",
      type: "string",
      optional: true,
      facet: true,
      infix: true,
    },
    {
      name: "unofficial_commercial_info",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "certificate_sub_type",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "verifying_agency",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "external_consignor",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "product",
      type: "object[]",
      infix: true,
      optional: true,
      fields: [
        {
          name: "id",
          type: "string",
          infix: true,
        },
        {
          name: "description",
          type: "string",
          infix: true,
        },
        {
          name: "product_botanical_name",
          type: "string",
          infix: true,
          optional: true,
        },
        {
          name: "product_common_name",
          type: "string",
          infix: true,
          optional: true,
        },
        {
          name: "sub_class",
          type: "string",
          optional: true,
          infix: true,
          facet: true,
        },
        {
          name: "class",
          type: "string",
          optional: true,
          infix: true,
          facet: true,
        },
        {
          name: "quantity_amount",
          type: "string",
          optional: true,
          infix: true,
          facet: true,
        },
        {
          name: "quantity_type",
          type: "string",
          optional: true,
          infix: true,
          facet: true,
        },
        {
          name: "wine_name",
          type: "string",
          optional: true,
          infix: true,
        },
        {
          name: "net_volume",
          type: "string",
          optional: true,
          infix: true,
        },
        {
          name: "package_quantity",
          type: "string",
          optional: true,
          infix: true,
        },
        {
          name: "package_type",
          type: "string",
          optional: true,
          infix: true,
        },
        {
          name: "product_id",
          type: "string",
          optional: true,
          infix: true,
        },
        {
          name: "exporter_reference",
          type: "string",
          optional: true,
          infix: true,
        },
        {
          name: "description",
          type: "string",
          optional: true,
          infix: true,
        },
        {
          name: "net_weight",
          type: "string",
          optional: true,
          infix: true,
        },
      ],
    },
    {
      name: "product_descriptions",
      type: "string[]",
      infix: true,
      optional: true,
    },
    {
      name: "product_net_weights",
      type: "string[]",
      infix: true,
      optional: true,
    },
    {
      name: "product_net_volumes",
      type: "string[]",
      infix: true,
      optional: true,
    },
    {
      name: "product_eligibility_countries",
      type: "string[]",
      infix: true,
      optional: true,
    },
    {
      name: "product_container_numbers",
      type: "string[]",
      infix: true,
      optional: true,
    },
    {
      name: "product_seals",
      type: "string[]",
      infix: true,
      optional: true,
    },
    {
      name: "product_NZHSC_codes",
      type: "string[]",
      infix: true,
      optional: true,
    },
    {
      name: "product_productionBatch_ids",
      type: "string[]",
      optional: true,
      infix: true,
    },
    {
      name: "product_botanical_name",
      type: "string[]",
      infix: true,
      optional: true,
    },
    {
      name: "unique_consignment_ref",
      type: "string",
      infix: true,
      optional: true,
    },
    {
      name: "product_item_marks",
      type: "string[]",
      infix: true,
      optional: true,
    },
    {
      name: "product_unofficial_commercial_ref",
      type: "string[]",
      optional: true,
      infix: true,
    },
    {
      name: "product_unofficial_commercial_info",
      type: "string[]",
      optional: true,
      infix: true,
    },
    {
      name: "local_carrier",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "carrier_name",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "conveyance_reference",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "template_id",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
      facet: true,
    },
    {
      name: "template_version_id",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
      facet: true,
    },
    {
      name: "submission_layout",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
      facet: true,
    },
    {
      name: "transport_mode",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
      facet: true,
    },
    {
      name: "org_cert_ref_code",
      type: "string",
      optional: true,
      facet: true,
      infix: true,
      sort: true,
    },
    {
      name: "vessel",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "sub_class",
      type: "string[]",
      optional: true,
      infix: true,
      facet: true,
    },
    {
      name: "class",
      type: "string[]",
      optional: true,
      infix: true,
      facet: true,
    },
    {
      name: "requires_attention",
      type: "bool",
      optional: true,
      facet: true,
    },
    {
      name: "consignor_id",
      type: "string",
      facet: true,
      infix: true,
      sort: true,
      optional: true,
    },
    {
      name: "consignee_id",
      type: "string",
      sort: true,
      infix: true,
      optional: true,
    },
    {
      name: "third_party_consignor",
      type: "string[]",
      infix: true,
      facet: true,
      optional: true,
    },
    {
      name: "commodity",
      type: "string",
      optional: true,
      facet: true,
      infix: true,
    },
    {
      name: "certificate_type",
      type: "string",
      optional: true,
      facet: true,
      infix: true,
    },
    {
      name: "destination_market",
      type: "string",
      optional: true,
      facet: true,
      infix: true,
    },
    {
      name: "order_number",
      type: "string",
      optional: true,
      infix: true,
    },
    {
      name: "consignee_name",
      type: "string",
      optional: true,
      infix: true,
      sort: true,
    },
    {
      name: "consignee_country",
      type: "string",
      optional: true,
      infix: true,
    },
    {
      name: "exporter_country",
      type: "string",
      optional: true,
      infix: true,
    },
    {
      name: "first_consignee_name",
      type: "string",
      optional: true,
      infix: true,
    },
    {
      name: "exported_by_another_party",
      type: "bool",
      optional: true,
    },
    {
      name: "format_for_shipping",
      type: "string",
      optional: true,
      infix: true,
    },
    {
      name: "total_cases",
      type: "string",
      optional: true,
      infix: true,
    },
    {
      name: "created_at",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "created_ts",
      type: "int64",
      optional: true,
      sort: true,
      infix: true,
    },
  ],
  visibility: CollectionVisibility.Private,
}
